import { useState } from 'react'
import Button from '../../../components/common/Button'
import CodeInput from '../../../components/common/CodeInput'
import api from '../../../utils/api'
import { toast } from '../../../components/toast/CustomToast'

const VerificationCodeStep = ({ formData, setFormData, onNext, onBack, error, userId }) => {
  const [codeError, setCodeError] = useState('')
  const [validating, setValidating] = useState(false)
  const [resending, setResending] = useState(false)

  const isCodeComplete = formData.emailCode.every(digit => digit !== '')

  const handleResendCode = async () => {
    setResending(true)
    try {
      await api.post('/company-activation/resend-code', {
        company_id: formData.companyId
      })
      toast.success('Código reenviado com sucesso! Verifique seu email.')
      setCodeError('')
    } catch (err) {
      const errorMsg = err.response?.data?.detail || 'Erro ao reenviar código. Tente novamente.'
      toast.error(errorMsg)
    } finally {
      setResending(false)
    }
  }

  const handleValidateCode = async () => {
    setCodeError('')
    const code = formData.emailCode.join('')

    if (code.length !== 6) {
      setCodeError('Por favor, digite todos os 6 dígitos')
      return
    }

    setValidating(true)
    try {
      // Confirm activation - validates code and CREATES user + registers LGPD consent
      const confirmResponse = await api.post('/company-activation/confirm-activation', {
        company_id: formData.companyId,
        code: code
      })

      // Store the user_id from confirmation response for step 6
      if (confirmResponse.data.user_id) {
        localStorage.setItem('activation_user_id', confirmResponse.data.user_id)
      }

      toast.success('Código validado com sucesso!')
      setValidating(false)
      onNext()
    } catch (err) {
      const errorMsg = err.response?.data?.detail || 'Erro ao validar código. Tente novamente.'
      setCodeError(errorMsg)
      setValidating(false)
    }
  }

  return (
    <div className="animate-fade-in">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Verificação de Email
      </h2>
      <p className="text-gray-600 dark:text-gray-400 mb-6">
        Enviamos um código de 6 dígitos para <strong>{formData.adminEmail}</strong>
      </p>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-8">
        <p className="text-blue-900 dark:text-blue-200 text-sm flex items-center">
          <span className="material-icons text-sm mr-2">info</span>
          Verifique seu email e digite o código recebido
        </p>
      </div>

      <div className="mb-6">
        <CodeInput
          value={formData.emailCode}
          onChange={(newCode) => setFormData({ ...formData, emailCode: newCode })}
          disabled={validating}
        />
      </div>

      {(codeError || error) && (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6">
          <p className="text-red-800 dark:text-red-200 text-sm">{codeError || error}</p>
        </div>
      )}

      <p className="text-center text-sm text-gray-600 dark:text-gray-400 mb-6">
        Não recebeu o código?{' '}
        <button
          type="button"
          onClick={handleResendCode}
          disabled={resending || validating}
          className="text-blue-500 hover:text-blue-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {resending ? 'Reenviando...' : 'Reenviar'}
        </button>
      </p>

      <div className="flex gap-3">
        <Button variant="secondary" onClick={onBack} disabled={validating} className="flex-1">
          Voltar
        </Button>
        <Button variant="primary" onClick={handleValidateCode} loading={validating} disabled={!isCodeComplete || validating} className="flex-1">
          Verificar
        </Button>
      </div>
    </div>
  )
}

export default VerificationCodeStep
